import type { RegulatoryIdentity } from '../counterparties/counterparties.dto.js';

export const locationKindValues = ['fixed', 'mobile', 'temporary'] as const;
export type LocationKind = (typeof locationKindValues)[number];

export interface LocationDto {
  id: string; // UUID
  companyId: string;
  storeId: string;
  name: string;
  code: string; // unique per company
  kind: LocationKind;
  rcNumber: string;
  regulatoryIdentity?: RegulatoryIdentity | null;
  regulatoryEntityId?: string | null;
  timezone?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  isActive: boolean;
  createdAt: string; // ISO timestamp
  updatedAt: string; // ISO timestamp
  // Invariant: storeId must belong to companyId; locations never cross company/store boundaries.
}

export interface CreateLocationRequest {
  companyId: string;
  storeId: string;
  name: string;
  code: string;
  kind: LocationKind;
  rcNumber: string;
  timezone?: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  isActive: boolean;
}

export interface CreateLocationResponse {
  location: LocationDto;
}

export interface UpdateLocationRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  name?: string;
  code?: string;
  kind?: LocationKind;
  rcNumber?: string;
  timezone?: string | null;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  isActive?: boolean;
}

export interface UpdateLocationResponse {
  location: LocationDto;
}

export interface GetLocationRequest {
  companyId: string;
  locationId: string;
}

export interface GetLocationResponse {
  location: LocationDto;
}

export interface ListLocationsByStoreRequest {
  companyId: string;
  storeId: string;
  page?: number;
  pageSize?: number;
}

export interface ListLocationsByStoreResponse {
  items: LocationDto[];
  page: number;
  pageSize: number;
  total: number;
}
